const BASE = "https://online-attendance-server.vercel.app/api";

export async function checkIn(username, deviceId) {
  const res = await fetch(`${BASE}/checkin.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, deviceId })
  });
  return res.json();
}

export async function checkOut(username, deviceId) {
  const res = await fetch(`${BASE}/checkout.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, deviceId })
  });
  return res.json();
}

export async function fetchAttendance() {
  const res = await fetch(`${BASE}/attendance.js`);
  return res.json();
}

export async function getStatus(username, deviceId) {
  const res = await fetch(`${BASE}/status.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, deviceId }),
  });
  return res.json();
}


export async function resetDevice(username, adminSecret, newDeviceId) {
  const res = await fetch(`${BASE}/reset-device.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, adminSecret, newDeviceId }),
  });
  return res.json();
}

// export async function checkGeolocation(coords) {
//   const res = await fetch(`${BASE}/checkGeolocation.js`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ coords }),
//   });
//   return res.json();
// }